/**
 * Le regole della password: **le stesse del server** (`_PASSWORD_RE` in
 * `app/api/v1/auth.py`). Se lì cambiano, qui vanno cambiate, altrimenti la
 * spunta verde promette qualcosa che poi viene rifiutato.
 *
 * In un modulo proprio (non nel componente RequisitiPassword): un file che
 * esporta componenti deve esportare solo componenti (fast refresh di Vite).
 */

export const REGOLE_PASSWORD = [
  { chiave: "lunghezza", verifica: (p: string) => p.length >= 8 },
  { chiave: "maiuscola", verifica: (p: string) => /[A-Z]/.test(p) },
  { chiave: "minuscola", verifica: (p: string) => /[a-z]/.test(p) },
  { chiave: "cifra", verifica: (p: string) => /\d/.test(p) },
] as const;

/** Un requisito in più, consigliato ma non preteso dal server. */
export const SIMBOLO = {
  chiave: "simbolo",
  verifica: (p: string) => /[^A-Za-z0-9]/.test(p),
};

export function passwordValida(password: string): boolean {
  return REGOLE_PASSWORD.every((r) => r.verifica(password));
}
